import { render, staticRenderFns } from "./tmts-icon.vue?vue&type=template&id=1f143ff4&scoped=true"
import script from "./tmts-icon.vue?vue&type=script&lang=js"
export * from "./tmts-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f143ff4",
  null
  
)

export default component.exports